<template>
  <div class="add-app-com">
    <el-form
      ref="addAppRef"
      :model="form"
      :rules="rules"
      :class="{'add-app-form':true,'add-app-form-pop':type==='pop'}"
      >
      <el-form-item prop="country" :label="type==='pop'?$t('messages.home.tip52'):''">
        <el-select
          v-model="form.country"
          size="medium"
          style="width:168px;height: 40px;"
          filterable
          @focus="handleSetOptionWidth"
          :placeholder="$t('messages.other.other54')"
        >
          <el-option
            v-for="(item, i) in countryOptions"
            :key="i"
            :label="item.name"
            :value="item.id"
            :style="{width:selectOptionWidth || 'auto'}"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="app_store_url" :class="{'app-store-url':urlErr}" 
        :label="type==='pop'?productLinkLabel:''">       
        <el-input @change="changeAppStoreUrl" @input="handleUrlInput" 
          style="width: 400px;" ref="addAppInputRef" v-model.trim="form.app_store_url" 
          :placeholder="$t('messages.home.tip19')"></el-input>
        <p v-if="urlErr" class="errTip">{{urlErrTip}}</p>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @mousedown.native="validate"
          :disabled="!form.app_store_url"
          class="add-btn"
        >
          {{ btnText }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { countryAll, countryAllCN } from '@/js/varible'
import { throttleFn } from '@/js/common'

const APPLE_APP_PREFIX = 'https://apps.apple.com/'
const APPLE_COUNTRY_RE = /apple\.com\/([a-z]{2})(?:-[a-z]{2,3})?\/app/i

export default {
  props: {
    btnText: {
      type: String,
      default: 'Get Your App\'s Promotion Plan',
    },
    type:{
      type: String,
      default: 'page',
    },
    storeName: {
      type: String,
      default: 'Google Play',
    },
  },
  data(){
    return{
      form:{
        country:'ID',
        app_store_url:'',
      },
      rules:{
        app_store_url: [
          {
            validator: (rule, value, callback) => {
              this.validateStoreUrl(value, callback)
            },
            trigger: ['blur', 'change'],
          },
        ],
      },
      // countryOptions: this.initSelectOptions(countryAll),
      urlErr:false,
      urlErrTip:'',
      loading:false,
      selectOptionWidth:null,
    }
  },
  created(){
    let query = this.$route.query
    if(query.product_url){
      this.form.app_store_url = query.product_url
      this.form.source = 3
      this.$nextTick(()=>{
        this.validate()
      })
    }else{
      this.form.source = this.type==='pop'?1:0
    }
  },
  watch: {
    storeName() {
      this.form.app_store_url = ''
      this.urlErr = false
      if (this.$refs.addAppRef) {
        this.$refs.addAppRef.clearValidate()
      }
    },
  },
  computed:{
    countryOptions(){
      if(this.$i18n.locale === 'en'){
        return this.initSelectOptions(countryAll)
      }
      return this.initSelectOptions(countryAllCN)
    },
    isAppleStore() {
      return this.storeName !== 'Google Play'
    },
    productLinkLabel() {
      return this.$t('messages.gLogin.link').replace('Google Play', this.storeName)
    },
  },
  methods:{
    handleSetOptionWidth(event){
      this.$nextTick(() => {
        this.selectOptionWidth = event.srcElement.offsetWidth + 'px';
      }); 
    },
    handleUrlInput(value){
      this.urlErr = false
      this.syncAppleCountryFromUrl(value)
    },
    syncAppleCountryFromUrl(value) {
      if (!this.isAppleStore) {
        return
      }
      const matched = this.normalizeStoreUrl(value).match(APPLE_COUNTRY_RE)
      if (!matched) {
        return
      }
      const country = matched[1].toUpperCase()
      const exists = this.countryOptions.some(item => item.id === country)
      if (exists) {
        this.form.country = country
      }
    },
    changeAppStoreUrl(){
      this.urlErr = false
    },
    normalizeStoreUrl(value) {
      return String(value || '')
        .replace(/[\u200B-\u200D\u2060\uFEFF\u200E\u200F]/g, '')
        .trim()
    },
    isAppleStoreUrl(value) {
      return this.normalizeStoreUrl(value).toLowerCase().startsWith(APPLE_APP_PREFIX)
    },
    validateStoreUrl(value, callback) {
      this.urlErr = false
      this.urlErrTip = this.$t('messages.createCampaign.create164')
      const url = this.normalizeStoreUrl(value)
      if (!url) {
        callback()
        return
      }
      if (this.isAppleStoreUrl(url)) {
        callback()
        return
      }
      if (this.isAppleStore) {
        /* eslint-disable standard/no-callback-literal */
        return callback(new Error(this.$t('messages.createCampaignBrush.appleLinkErr')))
      }
      var domain = url.split('/');
      if(domain[2]==='play.google.com'){
        callback()
      }else{
        /* eslint-disable standard/no-callback-literal */
        return callback(new Error(this.$t('messages.home.tip20')))
      }
    },
    postCreateApp:throttleFn(function(req_params){
      if(this.type === 'pop'){
        req_params.is_need_screenshot = 1
      }
      this.$http
        .get('/api/applications/gpinfo/', {params: req_params})
        .then(res => {
          if(res.data.application){
            let params = {
              ...this.form,
              ...res.data.application,
            }
            this.$http
              .post('/api/applications/create/', params)
              .then(data => {
                this.loading = false
                this.form.country = 'ID'
                this.form.app_store_url = ''                
                if(this.type === 'pop'){
                  this.$emit('callback', res.data.application.screenshots || [])
                  this.form.source = 1
                }else{
                  this.$emit('callback')
                  this.form.source = 0
                }
                document.getElementById('elMain').scrollTop = 0;
                this.notifyOpen(this.$t('messages.createCampaign.create153'))
              })
              .catch(error => {
                this.loading = false
                this.notifyOpen('Error', this.executeError(error), 'error')
              })
          }
          if(res.data.application===null){
            this.loading = false
            this.urlErr = true
            this.urlErrTip=this.$t('messages.createCampaign.create164')
          }
        })
        .catch(() => {
          this.loading = false
          this.urlErr = true
          this.urlErrTip=this.$t('messages.createCampaign.create164')
          // this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },3000),
    validate() { 
      this.$refs.addAppRef.validate((valid, data) => {
        if(!this.form.app_store_url){
          this.urlErr = true
          this.urlErrTip=this.$t('messages.tipError.emptyErr')
        }
        if (valid) {
          this.loading = true
          let req_params = {
            country: this.form.country,
            pre_info: this.normalizeStoreUrl(this.form.app_store_url),
          }
          this.postCreateApp(req_params)
        }
      })
    },
  },
}
</script>

<style lang="scss">
.add-app-com{
  .add-app-form{
    display: flex;
    justify-content: space-between;
    width: 60%;
    .add-btn{
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
      min-width: 120px;
    }
    .el-input__inner{
      height: 40px;
      line-height: 40px;
    }
    .el-form-item{
      margin-right: 16px;
    }
  }
  .app-store-url{
    .el-input__inner{
      border-color: #f56c6c;
    }
  }
  .add-app-form-pop{
    // display: block;
    flex-direction: column;
    .el-select,.el-input__inner,.el-input{
      width: 462px !important;
    }
    .add-btn{
      height: 32px;
    }
    .el-button.is-disabled, 
    .el-button.is-disabled:hover, 
    .el-button.is-disabled:focus{
      background-color: rgba(102,102,255,0.5);
    }
  }
  .errTip{
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
}
@media screen and (max-width: 901px) {
  .add-app-com{
    .add-app-form{
      flex-direction: column;
      width: 100% !important;
      .el-form-item{
        margin-right: 0 !important;
      }
      .el-select,.el-input,.add-btn{
        width: 100% !important;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .add-app-com{
    .add-app-form-pop{
      .el-select,.el-input__inner,.el-input{
        width: 300px !important;
      }
    }
  }
}

</style>
